module.exports = __webpack_public_path__ + "img/42.3061b5ae.png";